import { useContext } from "react";
import { AuthContext, AuthContextType } from "../providers/AuthProvider";

export default function useAuth(): AuthContextType {
    return useContext(AuthContext);
}